import { z } from 'zod';

export enum EquipmentTypes {
    Van = 'VAN',
    Flatbed = 'FLATBED',
    Reefer = 'REEFER',
}
export enum RateTypes {
    Spot = 'Spot',
    Contract = 'Contract',
    Fuel = 'Fuel',
}

export type RateResponse = z.infer<typeof IqNtlResponseSchema>;

export type RateInfo = { errored: boolean, rates: RateResponse };

export type RatesByType = {
    errored: boolean,
    [RateTypes.Spot]: RateResponse,
    [RateTypes.Contract]: RateResponse,
    [RateTypes.Fuel]: RateResponse,
};

export type RatesCache = {
    errored: boolean;
    [EquipmentTypes.Van]: RatesByType;
    [EquipmentTypes.Flatbed]: RatesByType;
    [EquipmentTypes.Reefer]: RatesByType;
};


const IqNtlTrendSchema = z.object({
    icon: z.string(),
    message: z.string(),
});

export const IqNtlResponseSchema = z.object({
    national: z.object({
        changePercent: z.number(),
        changeRate: z.number(),
        isChangePositive: z.boolean(),
        isChangeNegative: z.boolean(),
        isChangeNeutral: z.boolean(),
        rates: z.object({
                mile: z.array(
                    z.object({
                        date: z.string(),
                        average: z.number(),
                    }),
                ),
            }),
    }),
});

export enum NtlEquipType {
    Unknown = '',
    Van = 'VAN',
    Reefer = 'REEFER',
    Flatbed = 'FLATBED',
}
export enum NtlTimeInterval {
    Unknown = '',
    Weekly = 'Week',
    Monthly = 'Month',
}
export enum NtlRateType {
    Unknown = '',
    Spot = 'Spot',
    Contract = 'Contract',
    Fuel = 'Fuel',
}
export enum NtlCountryType {
    US = 'US',
    CA = 'CA',
    Unknown = '',
}

export interface IIqRateNtlStateService {
    fetchNtlHistoricalRate(
        equipType: NtlEquipType,
        rateType: NtlRateType,
        interval: NtlTimeInterval,
        country: NtlCountryType,
    ): Promise<IIqNtlResponse>;
}

export const emptyNtlResponse: IIqNtlResponse = {
    national: {
        changePercent: 0,
        changeRate: 0,
        isChangePositive: false,
        isChangeNegative: false,
        isChangeNeutral: false,
        rates:
            {
                mile: [{
                    date: new Date().toISOString(),
                    average: 0,
                }],
            },

    },
};

export type IIqNtlTrendSchema = z.infer<typeof IqNtlTrendSchema>;
export type IIqNtlResponse = z.infer<typeof IqNtlResponseSchema>;
